"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextLink = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var common_utils_1 = require("../../tools/common-utils");
var Typography_1 = require("../Typography");
var styles_1 = require("./styles");
var TextLink = function (_a) {
    var target = _a.target, href = _a.href, rel = _a.rel, className = _a.className, _b = _a.color, color = _b === void 0 ? 'accent' : _b, underline = _a.underline, children = _a.children, _c = _a.strong, strong = _c === void 0 ? true : _c, onClick = _a.onClick, dataTestID = _a["data-testid"];
    return ((0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ as: "a", size: "base", strong: strong, underline: underline, className: (0, classnames_1.default)("\n    squid-cursor-pointer\n    active:squid-outline-none\n    focus:squid-outline-none\n    ", (0, common_utils_1.toArray)(underline ? styles_1.styles.underline : styles_1.styles.default), styles_1.colorStyles[color], className), "data-testid": dataTestID, htmlProps: {
            tabIndex: 0,
            href: href,
            target: target,
            onClick: onClick,
            rel: rel,
        } }, { children: children })));
};
exports.TextLink = TextLink;
